import * as module from "react";
export default module;
export { useCallback, useContext, useEffect, useImperativeHandle, useLayoutEffect, useDebugValue, useMemo, useReducer, useRef, useState, createContext, createElement, forwardRef, cloneElement, createRef, memo, lazy, isValidElement, } from "react";
//# sourceMappingURL=main.entry.mjs.mjs.map